import React, { useState } from 'react';
import { Field, Form, decimalProps, commandId } from './CkOperationsShared';

// F4: move a lot (whole, or part with a quantity) to another section at this site.
// Leave quantity blank to move the whole lot. A received transfer lot with no
// section is assigned one the same way.
export default function MoveLot({ lot, sections, run, busy }) {
  const [moveId] = useState(commandId);
  const [to, setTo] = useState('');
  const [qty, setQty] = useState('');
  const options = sections.filter(s => s.section_id !== lot.section_id).map(s => ({ value: s.section_id, label: s.name || s.section_id }));
  const current = sections.find(s => s.section_id === lot.section_id);
  return <Form title="Move to section" submit="Move lot" busy={busy || lot.status !== 'available'} onSubmit={() => run(`/lots/${encodeURIComponent(lot.lot_id)}/move`, { move_id: moveId, to_section_id: to, ...(qty.trim() ? { qty: qty.trim() } : {}) })}>
    <p className="ck-empty">Now in: {current ? (current.name || current.section_id) : (lot.section_id || 'no section')}</p>
    <Field label="Destination section" required value={to} onChange={e => setTo(e.target.value)} options={[{ value: '', label: 'Select section' }, ...options]} />
    <Field label="Quantity to move (blank = whole lot)" value={qty} onChange={e => setQty(e.target.value)} {...decimalProps} />
  </Form>;
}
